import { render, staticRenderFns } from "./CatalogSlider.vue?vue&type=template&id=05386ca8&scoped=true&"
import script from "./CatalogSlider.vue?vue&type=script&lang=js&"
export * from "./CatalogSlider.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSlider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CatalogSlider.vue?vue&type=style&index=1&id=05386ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05386ca8",
  null
  
)

export default component.exports